var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "mb-2", staticStyle: { "max-width": "40rem" } },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.loading, rounded: "sm" } },
            [
              _c("b-card-title", [
                _c("h4", { staticClass: "ml-3" }, [
                  _vm._v("Olá,\n                    "),
                  _c("small", [_vm._v("informe a nova senha!")])
                ])
              ]),
              _vm._v(" "),
              _vm.user
                ? _c(
                    "b-card-body",
                    [
                      _c("b-row", [
                        _c(
                          "b",
                          [
                            _vm.user.distribuidor
                              ? _c("b-col", [
                                  _c("b", [_vm._v(" Distribuidor: ")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.user.distribuidor.codigo) +
                                      " - " +
                                      _vm._s(_vm.user.distribuidor.nome) +
                                      "\n                        "
                                  )
                                ])
                              : _c("b-col", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.user.name) +
                                      "\n                        "
                                  )
                                ])
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c("b-col", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.user.email) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          staticClass: "mt-3",
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.salvar.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { sm: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "input-group-1",
                                        label: "Nova Senha",
                                        "label-for": "password"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "password",
                                          type: "password",
                                          required: "",
                                          state: _vm.validation
                                        },
                                        model: {
                                          value: _vm.password,
                                          callback: function($$v) {
                                            _vm.password = $$v
                                          },
                                          expression: "password"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        { attrs: { state: _vm.validation } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.passwordError) +
                                              "\n                                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-valid-feedback",
                                        { attrs: { state: _vm.validation } },
                                        [
                                          _vm._v(
                                            "\n                                    Senha Válida\n                                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { sm: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "input-group-1",
                                        label: "Confirme a Senha",
                                        "label-for": "confirm"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "confirm",
                                          type: "password",
                                          required: "",
                                          state: _vm.validationConfirm
                                        },
                                        model: {
                                          value: _vm.confirm,
                                          callback: function($$v) {
                                            _vm.confirm = $$v
                                          },
                                          expression: "confirm"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state: _vm.validationConfirm
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.passwordError) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "primary",
                                        type: "submit"
                                      }
                                    },
                                    [_vm._v("salvar")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-176eef2c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-176eef2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/RememberReset.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-176eef2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/RememberReset.vue
// module chunks = 2